import { useEffect } from "react";
import { getBookingDetails } from "../mytrips/services/mytrips.services";
import Loading from "../../components/spinner/Loading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useLocation, useNavigate } from "react-router";
// import HeaderLogo from "../../assets/images/big smile logo-01.png";
import HeaderLogo from "../../assets/images/logo.png";
import DONOTTHINGS from "../../assets/images/do-not-things.png";
import moment from "moment";

const TicketPrint = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state?.mytrips?.loading);
  const fetchLoading = useAppSelector(
    (state) => state?.bookingcancellation?.loading
  );
  const location = useLocation();

  const BookingDetails = useAppSelector(
    (state) => state?.mytrips?.BookinDetails
  );

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const bookingId = params.get("bookingId");
    dispatch(
      getBookingDetails({
        Booking_RefNo: bookingId,
        Airline_PNR: "",
      })
    );
  }, []);

  return (
    <>
      <Loading loading={loading || fetchLoading} backgroundColor="white" />
      {!loading && (
        <div className="cancellation-view">
          <div className="container ">
            <div className="row  mb-2">
              <img
                src={HeaderLogo}
                alt=""
                style={{ width: 200, margin: "0 auto" }}
              />
            </div>
            <div className="row">
              <div className="col col-lg-6">
                <div className="info-wrapper print-view">
                  <h4 className="color-deepgreen">
                    {BookingDetails?.CustomerDetail?.Customer_Name}
                  </h4>
                  <p className="mb-1">
                    <span className="fw-600 color-deepgreen">Mo. no.:</span>{" "}
                    {BookingDetails?.PAX_Mobile}
                  </p>
                  <p className="m-0">
                    <span className="fw-600 color-deepgreen">Email ID: </span>
                    {BookingDetails?.PAX_EmailId}
                  </p>
                </div>
              </div>
              <div className="col col-lg-6">
                <div className="info-wrapper print-view">
                  <p className="mb-2">
                    <span className="fw-600 color-deepgreen">PNR.: </span>
                    {BookingDetails?.AirPNRDetails?.map(
                      (pnrdetails: any, index: number) => {
                        if (index + 1 < BookingDetails?.AirPNRDetails?.length) {
                          return pnrdetails?.Airline_PNR + ", ";
                        } else {
                          return pnrdetails?.Airline_PNR;
                        }
                      }
                    )}
                  </p>
                  <p className="mb-2">
                    <span className="fw-600 color-deepgreen">
                      Booking Ref No.:{" "}
                    </span>
                    {BookingDetails?.portal_booking_no}
                  </p>
                  <p className="mb-2">
                    <span className="fw-600 color-deepgreen">
                      Booking Date:{" "}
                    </span>
                    {moment(
                      BookingDetails?.Booking_DateTime,
                      "DD/MM/YYYY HH:mm:ss"
                    ).format("DD/MM/YYYY | hh:mm:ss A")}
                  </p>
                </div>
              </div>
            </div>
            {BookingDetails &&
              BookingDetails?.AirPNRDetails?.map(
                (tripInfo: any, tripIndex: any) => {
                  // if (
                  //   tripInfo?.PAXTicketDetails?.some(
                  //     (e: any) => e?.TicketStatus === "Live"
                  //   )
                  // ) {
                  return (
                    <div key={tripIndex}>
                      <div className="row mt-3">
                        <div className="col-12">
                          <div className="info-wrapper">
                            {tripInfo?.Flights?.flatMap((flight: any) =>
                              flight?.Segments?.map(
                                (item: any, index: number) => (
                                  <div
                                    className="route-timing justify-content-between mb-4"
                                    key={index}
                                  >
                                    <div
                                      className="route-strating"
                                      style={{ width: "40%" }}
                                    >
                                      {item?.Origin}
                                      <span>
                                        {item?.Origin_Terminal
                                          ? `Terminal : ${item?.Origin_Terminal}`
                                          : ""}
                                      </span>
                                      <p className="mt-1">
                                        {moment(
                                          item?.Departure_DateTime,
                                          "MM/DD/YYYY HH:mm:ss"
                                        ).format("ddd, DD MMM. YYYY HH:mm")}
                                      </p>
                                    </div>
                                    <div className="cunsume-time">
                                      <span>
                                        {item?.Airline_Code +
                                          " - " +
                                          item?.Flight_Number}
                                      </span>
                                      <div className="position-relative cancellation-cunsume-pic">
                                        <span
                                          style={{
                                            position: "absolute",
                                            right: -3,
                                            top: -10,
                                          }}
                                        >
                                          ►
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      className="route-strating text-end"
                                      style={{ width: "40%" }}
                                    >
                                      {item?.Destination}
                                      <span>
                                        {item?.Destination_Terminal
                                          ? `Terminal : ${item?.Destination_Terminal}`
                                          : ""}
                                      </span>
                                      <p className="mt-1">
                                        {moment(
                                          item?.Arrival_DateTime,
                                          "MM/DD/YYYY HH:mm:ss"
                                        ).format("ddd, DD MMM. YYYY HH:mm")}
                                      </p>
                                    </div>
                                  </div>
                                )
                              )
                            )}
                            <hr />
                            <table className="cancellation-table">
                              <tr
                                style={{
                                  background: "#000",
                                  color: "#fff",
                                  textAlign: "center",
                                }}
                              >
                                <th>Passenger Name</th>
                                <th>Flight</th>
                                <th>Fare Type</th>
                                <th>Add-on Services</th>
                              </tr>
                              {tripInfo?.PAXTicketDetails?.map((pax: any) => {
                                // if (pax?.TicketStatus === "Live") {
                                return (
                                  pax?.TicketDetails &&
                                  pax?.TicketDetails.map(
                                    (ticketDetail: any) => {
                                      return ticketDetail?.SegemtWiseChanges
                                        ?.length > 0
                                        ? ticketDetail?.SegemtWiseChanges.map(
                                            (
                                              segment: any,
                                              index: number,
                                              array: any[]
                                            ) => {
                                              return (
                                                <tr
                                                  key={`${ticketDetail?.Ticket_Number}-${index}`}
                                                  style={{
                                                    backgroundColor:
                                                      pax?.TicketStatus ===
                                                      "Tocancel"
                                                        ? "#ffd5d3"
                                                        : "unset",
                                                  }}
                                                >
                                                  {index === 0 && (
                                                    <>
                                                      <td
                                                        rowSpan={array.length}
                                                      >
                                                        {`${pax?.Title} ${pax?.First_Name} ${pax?.Last_Name} `}
                                                        {pax?.TicketStatus ===
                                                        "Tocancel" ? (
                                                          <strong>
                                                            (Tocancel)
                                                          </strong>
                                                        ) : (
                                                          ""
                                                        )}
                                                      </td>
                                                    </>
                                                  )}
                                                  <td className="text-center">
                                                    <p className="m-0">{`${segment?.Origin} - ${segment?.Destination}`}</p>
                                                  </td>
                                                  <td>
                                                    {pax?.Fares[0]?.Refundable
                                                      ? "Refundable"
                                                      : "Non Refundable"}
                                                  </td>
                                                  <td>
                                                    {`${
                                                      (pax?.SSRDetails[index] &&
                                                        pax?.SSRDetails[index]
                                                          ?.SSR_TypeDesc) ||
                                                      ""
                                                    }`}
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )
                                        : null;
                                    }
                                  )
                                );
                                // }
                              })}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                  // }
                }
              )}
            <div className="row">
              <div id="text-b83403863e" className="cmp-text">
                <p style={{ textAlign: "center" }} className="mt-3">
                  <b>PRIVACY POLICY</b>
                </p>
                <p>
                  Air India values your privacy. Our privacy policy (“
                  <b>Privacy Policy</b>") applies to all the Personal Data we
                  gather, and you share with us when you visit our websites, use
                  our apps, and utilize any services provided by Air India
                  including our loyalty program and live chat options. Once you
                  choose to provide us with Personal Data, Air India will only
                  use your information in accordance with this Privacy Policy.
                </p>
                <p>
                  This&nbsp;Privacy&nbsp;Policy&nbsp;is issued on behalf of the
                  Air India Limited and is hereinafter referred to as “
                  <b>Air India</b>”, “<b>we</b>”, “<b>us</b>”, or “<b>our</b>”
                  in this&nbsp;Privacy&nbsp;Policy. Air India Limited is the
                  controller or data fiduciary and responsible for this website.
                </p>
                <p>
                  To provide you with our services and the services available
                  through our website and application, Air India, as controller
                  (or data fiduciary) may process (including collect, store, and
                  transfer) your Personal Data. Please note that other airlines
                  have their own privacy policies. Air India recommends you read
                  those other policies if your travel plans include travel on
                  other airlines, as those policies may differ from Air India.
                </p>
                <p>
                  If you have any questions or comments, please contact our Data
                  Protection Team / Data Protection Officer as per the details
                  available in Section XIV of this Privacy Policy.
                </p>
                <p>
                  <b>I. The Types of Personal Data We Collect</b>
                </p>
                <p>
                  As per Air India’s business practices, we may collect Personal
                  Data from you. “Personal Information” or “Personal Data” means
                  any information about an individual from which that person can
                  be identified.
                </p>
                <p>
                  We currently collect and process Personal Data, which include:
                </p>
                <ul>
                  <li>
                    <b>Contact Information:</b> We collect your personal data
                    during the course of account creation on our
                    website/application as well as while booking our services.
                    This information includes your name, phone number, gender,
                    email Id, frequent flyer details, Address, and Nationality.
                  </li>
                  <li>
                    <b>Security Information</b>: Information related to website
                    password, application passwords etc.
                    <br />
                  </li>
                  <li>
                    <b>Financial Information:</b> This information includes
                    payment data, transactional data, credit/debit card
                    information, bank account number etc.
                    <br />
                  </li>
                  <li>
                    <b>Identification document/ information:</b> We may collect
                    advance passenger information like your visa details,
                    passport, or identity card details, including your passport
                    number, the country in which your passport was issued and
                    the expiry date.
                    <br />
                  </li>
                  <li>
                    <b>Health Information</b>: In order to offer better services
                    to you, we may collect certain health information of yours
                    such as allergies, medical information, disabilities etc.
                    <br />
                  </li>
                  <li>
                    <b>Information related to children:</b> We only process the
                    personal data of Minors with the prior consent of their
                    parents or their legal guardians. &nbsp;(Please refer to
                    Section III for more details.)
                    <br />
                  </li>
                  <li>
                    <b>Location and device information:</b> Your device location
                    (where you have permitted access to location), operating
                    system, IP address, browser information etc.
                    <br />
                  </li>
                  <li>
                    <b>Loyalty Account:</b> This data includes points and miles
                    data, your preferences and hobbies, language preferences
                    etc.
                    <br />
                  </li>
                  <li>
                    <b>Details pertaining to the services booked with us</b>
                    : During our course of interaction and for facilitating the
                    services you have booked with us we may gain insight into
                    some personal data, such as onward travel details, meal
                    preference, travel preferences check in date and time, seat
                    upgrades, Wi-Fi usage etc.
                    <br />
                  </li>
                  <li>
                    <b>Other Information</b>: This includes the data you choose
                    to share with us by means of interacting with our social
                    media pages or completing a flight satisfaction survey.
                    <br />
                  </li>
                  <li>
                    <b>Recruitment Data:</b> In case you apply to any of our
                    openings we shall process your data for assessing if you are
                    suitable for the position. In such scenarios we shall
                    collect your educational qualifications, professional
                    history, contact details etc.
                    <br />
                  </li>
                  <li>
                    In case, you share personal data with us which relates to
                    another person to provision a service from us, you are
                    responsible for ensuring the person knows and has consented
                    to us collecting and processing their personal information
                    in accordance with the provision of this privacy policy.
                    <br />
                  </li>
                </ul>
                <p>
                  Subject to applicable laws, we may monitor or record your
                  phone conversations for training and customer service
                  purposes, to comply with relevant legal obligations and to
                  make and defend claims. If you visit one of our Reservations
                  and Ticketing Offices or an Air India Lounge, you may be
                  monitored by closed circuit television for security purposes.
                </p>
                <p>
                  We also collect, use, and share aggregated data such as
                  statistical or demographic data for different purposes.
                  Aggregated data could be derived from your personal data but
                  is not considered personal data in law as this data will not
                  directly or indirectly reveal your identity. For example, we
                  may aggregate your usage data to calculate the percentage of
                  users accessing a specific website, mobile application, or
                  service feature. However, if we combine or connect aggregated
                  data with your Personal Data so that it can directly or
                  indirectly identify you, we treat the combined data as
                  Personal Data which will be used in accordance with this
                  Privacy Policy.
                </p>
                <p>
                  Where we need to collect Personal Data by law, or under the
                  terms of a contract we have with you, and you fail to provide
                  that data when requested, where permitted by applicable law,
                  we may not be able to perform the contract we have or are
                  trying to enter into with you (for example, to provide you
                  with access or use to our website, mobile application, and
                  other services).
                </p>
                <p>
                  <b>
                    II. How we Collect / Receive the Personal Data and the Use
                    of such Personal Data
                  </b>
                </p>
                <p>
                  We use different methods to collect Personal Data about you,
                  including through:
                </p>
                <p>
                  <b>Direct Interactions</b>: You may give us your Personal Data
                  by filling in forms or by corresponding with us by phone,
                  email, on our website, through live chat, or otherwise. This
                  includes Personal Data you provide when you:
                </p>
                <ul>
                  <li>apply or avail our products or services;</li>
                  <li>apply for job openings available at Air India;</li>
                  <li>create an account on our website or app;</li>
                  <li>use our live chat option “Ask AI.g”;</li>
                  <li>subscribe to our service or publications;</li>
                  <li>request marketing communications to be sent to you;</li>
                  <li>enter a competition, promotion, or survey; or</li>
                  <li>give us feedback or contact us.</li>
                </ul>
                <p>
                  <b>Indirect Interactions:</b> We may receive your personal
                  data from third parties such as:
                </p>
                <ul>
                  <li>
                    When you book our services using travel agents or
                    third-party websites
                  </li>
                  <li>
                    Airport Kiosks
                    <br />
                  </li>
                  <li>
                    Payment service providers
                    <br />
                  </li>
                  <li>
                    Partner Airlines and cooperation partners (such as star
                    alliance network)
                    <br />
                  </li>
                  <li>
                    Our affiliates to provide you with services in case of our
                    merger or amalgamation.
                    <br />
                  </li>
                  <li>
                    Referees and recruitment agencies in case you have applied
                    with us for any job openings.
                    <br />
                  </li>
                </ul>
                <p>
                  <b>Automated technologies or interactions</b>:&nbsp;As you
                  interact with our website or our services, we will
                  automatically collect technical data about your equipment,
                  browsing actions, and patterns. We collect this Personal Data
                  by using cookies, server logs, and other similar technologies.
                  We may also receive technical data about you if you visit
                  other websites employing our cookies. Please see our&nbsp;
                  <a
                    href="/in/en/cookie-policy.html"
                    title="cookies"
                    id="cookies"
                  >
                    <b>Cookie&nbsp;Policy</b>
                  </a>
                  &nbsp;for further details.
                </p>
                <p>
                  <b>III. Purpose of Processing and Lawful Basis:</b>
                  <br />
                </p>
                <p>
                  Your personal data can only be processed in accordance with
                  one of the lawful bases provided under applicable data privacy
                  laws. We may rely on different legal basis to comply with the
                  regulatory requirements.
                </p>
                <p>
                  <b>Fulfillment of our services:</b>
                </p>
                <p>
                  We may process your personal data in order to fulfill the
                  services you have booked with us. A contract exists between
                  you and Air India when you utilize our services by booking a
                  flight or cargo on our website, application or through any
                  third party. In order to fulfill our services, we shall
                  process your personal data for the purposes of identity
                  verification, reservations, check-in, and cargo management.
                </p>
                <p>
                  In this respect, information may also be processed for
                  providing ancillary services including but not limited to
                  additional baggage reservation, seat preference, meal
                  preference, cargo management, provision of wheelchair
                  assistance and facilitate duty free purchases.
                </p>
                <p>
                  Additionally, personal data may also be processed for the
                  purpose of preventing fraudulent transactions while receiving
                  payments from foreign nationals.
                </p>
                <p>
                  <i>
                    Legal Basis of processing for EEA (European Economic
                    Area)/UK:
                  </i>{" "}
                  We process your personal data for the fulfillment of
                  contractual obligations, for the above listed purposes.
                </p>
                <p>
                  <b>
                    To send communications related to the services availed with
                    us:
                  </b>
                </p>
                <p>
                  We may also process your personal data for sending
                  communications to you relevant to the services opted through
                  us such as flight tickets, gate change communication, changes
                  to the flight plan etc.{" "}
                  <i>
                    Please note that the communications transmitted for these
                    purposes do not require your explicit consent to be obtained
                    by us. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </i>
                </p>
                <p>
                  <i>
                    Legal Basis of processing for EEA/UK: We process your
                    personal data for the fulfillment of contractual
                    obligations, for the above purpose.
                  </i>
                  <b>
                    <i></i>
                  </b>
                </p>
                <p>
                  <b>To carry out marketing activities:</b>
                </p>
                <p>
                  We may process your personal data to carry out our marketing
                  campaigns by sending you personalized offers, and newsletters
                  through various channels such as email/WhatsApp/SMS/RCS/push
                  notification or any other channel. We shall send such
                  marketing communication only when you have opted-in or
                  subscribed to receive the same.&nbsp; If you have a Maharaja
                  Club Account, you may update your marketing preference at
                  Preference Centre in your account area at any time.
                  Additionally, you (including guest users) may opt out or
                  unsubscribe through the option available in such marketing
                  communication.
                </p>
                <p>
                  We may also process your personal data to carry out targeted
                  or personalized advertisement on our websites, third party
                  websites, social media platforms or any other digital
                  marketing channels to show personalized offers and products to
                  you. To opt out from such processing refer to our Cookies
                  Policy.
                </p>
                <p>
                  Please note: Opting out of receiving the marketing emails
                  shall not stop our communications sent for services availed
                  with us.
                </p>
                <p>
                  &nbsp;
                  <i>
                    Legal Basis of processing for EEA/UK: We process your
                    personal data on the basis of consent received, for the
                    above purpose.
                  </i>
                </p>
                <p>
                  <b>To improve our products and service:</b>
                </p>
                <p>
                  We may analyze your personal data in order to understand you
                  better, develop and improve our products and services. We may
                  also send survey links, make calls, invites for usability
                  testing and interviews to receive feedbacks from you on the
                  services availed from us. If you are a data subject from the
                  EU/UK region and does not wish to receive the survey links
                  from our side, you can raise a data subject request for right
                  to object
                  <b>.</b>
                </p>
                <p>
                  <i>
                    Legal Basis of processing for EEA/UK: We process your
                    personal data on the basis of legitimate interest, for the
                    above purpose.
                  </i>
                </p>
                <p>
                  <b>To manage our loyalty programme:</b>
                  <br />
                </p>
                <p>
                  We process your personal data to manage your Loyalty account
                  with us. The processing shall be in accordance with the
                  Loyalty terms and conditions which can be accessed
                  “https://www.airindia.com/in/en/maharaja-club/about/terms-conditions.html”.
                  We shall also process your data to determine offers and
                  provide personalised services based on your tier. Your
                  accounts may also be profiled and automated decisions maybe
                  made from such profiling activities.
                </p>
                <p>
                  At times, the personal data may be processed to manage your
                  Maharaja Points upon conducting transactions with our loyalty
                  partners and affiliate members.
                </p>
                <p>
                  <i>
                    Legal Basis of processing for EEA/UK: We process your
                    personal data on the basis of legitimate interest and
                    consent provided, for the above purpose.
                  </i>
                </p>
                <p>
                  <b>To manage your requests and complaints</b>:<br />
                </p>
                <p>
                  We may process your personal data under circumstances where
                  you have initiated contact with us for queries, requests, or
                  to address any grievances or feedback you may have pertaining
                  to the services you have availed from us.
                </p>
                <p>
                  <i>
                    Legal Basis of processing for EEA/UK: We process your
                    personal data on the basis of consent received, for the
                    above purpose.
                  </i>
                </p>
                <p>
                  <b>Health Data:</b>
                </p>
                <p>
                  We may process your health data only in scenarios where in you
                  have explicitly consented for receiving special assistance
                  before, during or after the flight. We may share this
                  information with our employees or third parties who shall be
                  involved in providing the assistance requested.
                </p>
                <p>
                  <i>
                    In case of an emergency scenario wherein medical assistance
                    is required, we shall process your data on the basis of
                    vital interest.
                  </i>
                </p>
                <p>
                  <b>
                    To manage any dispute, defend our legal claims and prevent
                    fraud:
                  </b>
                </p>
                <p>
                  We may process your personal data in order to defend our
                  claims in the court and fighting fraud. Additionally, we shall
                  process your personal data in accordance with any tax
                  obligation and legal obligations.
                </p>
                <p>
                  We may be required to disclose your personal data in case of
                  legal disputes or if queries are raised by authorities in
                  order to prevent, investigate or prosecute crimes including
                  identity fraud, terrorism etc.
                </p>
                <p>
                  <i>
                    Legal Basis of processing for EEA/UK: We process your
                    personal data on the basis of Legitimate Interest, for the
                    above purpose.
                  </i>
                </p>
                <p>
                  <b>Flight Planning and management:</b>
                </p>
                <p>
                  We may process your personal data in order to plan and manage
                  our fleet efficiently, which includes scheduling, route
                  optimization and crew allocation. This helps us to ensure
                  better operations along with minimal disruption to passengers
                  while consuming our services.
                </p>
                <p>
                  We may as well process personal data to audit, monitor and
                  improve our internal processes for smooth functioning of our
                  website, application, and internal procedure.
                </p>
                <p>
                  <i>
                    Legal Basis of processing for EEA/UK: We process your
                    personal data on the basis of Legitimate Interest, for the
                    above purpose.
                  </i>
                </p>
                <p>
                  <b>Processing job application:</b>
                  <br />
                </p>
                <p>
                  We shall process your personal data in order to process the
                  job applications submitted by you either through our website
                  or through third party agents or recruitment agencies.
                </p>
                <p>
                  <i>
                    Legal Basis of processing for EEA/UK: We process your
                    personal data on the basis of Legitimate Interest, for the
                    above purpose.
                  </i>
                </p>
                <p>
                  <b>IV. Personal Information of Children</b>
                </p>
                <p>
                  &nbsp; Due to the nature of our services as an airline, we may
                  collect travel information, which may include Personal Data of
                  persons below the age of majority (“
                  <b>children</b>”) when it is required to comply with the law,
                  or as otherwise required to provide transportation needs and
                  services (e.g. Air India may offer special discounts to
                  children and needs to assess fare eligibility, verification at
                  check in, and sharing of data to another airline if a transfer
                  is involved or for transport of unaccompanied children).
                </p>
                <p>
                  If you are a minor, you may use our services only with the
                  involvement of a parent or guardian. If personal data related
                  to minors has been collected without consent of their parents
                  or their legal guardians, they have the right to object to
                  processing and/or request deletion of such personal data
                  (Please refer to Section VII for more details on how to
                  exercise these rights).
                </p>
                <p>
                  <b>V. Who We Share your Personal Data With</b>
                </p>
                <p>We may share this information with:</p>
                <ul>
                  <li>
                    to other companies in the Air India Group; to customs,
                    border control, security, anti-terrorism and immigration
                    authorities, which require by law access to booking and
                    travel itinerary information including Passenger Name
                    Records for all passengers;
                  </li>
                  <li>
                    to our marketing or advertisement partners for sending
                    marketing emails;
                  </li>
                  <li>
                    to third parties including but not limited to other airline
                    partners, GDS partners,<u> </u>partners connected with our
                    Loyalty Programme, other service providers including those
                    who are acting as our agent or sub-contractor, including,
                    hoteliers, insurance companies, ground handling service
                    providers, medical assistance providers, caterers, credit
                    card and credit reference agencies, IT and system
                    administration services providers, data analytics & data
                    processing service providers, vendors, and our legal and
                    other professional advisors, including lawyers, bankers,
                    auditors, and insurers;
                  </li>
                  <li>
                    to third parties in connection with financing,
                    securitization, insuring, restructuring, assignment or other
                    disposal of all or part of our business or assets or in
                    relation to defence of claims;
                  </li>
                  <li>
                    to official authorities, including law enforcement,
                    governmental and regulatory authorities, including health
                    authorities: (a) if we believe disclosure is required by any
                    applicable law or regulation; (b) to protect and defend our
                    rights, or the rights or safety of third parties; or (c)
                    where it is in our legitimate interest to co-operate and
                    share information with such authorities;
                  </li>
                  <li>
                    where you have made a travel booking, to passengers
                    travelling under the same booking as you; or
                  </li>
                  <li>
                    to third parties to whom we may choose to sell, transfer, or
                    merge parts of our business or our assets. Alternatively, we
                    may seek to acquire other businesses or merge with them. If
                    a change happens to our business, then the new owners may
                    use your Personal Data in the same way as set out in this
                    Privacy Policy.
                  </li>
                  <li>
                    For recruitment purposes, we may also transfer your personal
                    data to third party service providers such as recruitment
                    agencies, background verification agencies, IT system
                    providers etc.
                  </li>
                </ul>
                <p>
                  <b>VI. How we Store, Retain, and Erase your Personal Data</b>
                </p>
                <p>
                  We will use technical and organizational measures to safeguard
                  your Personal Data in accordance with applicable laws.
                </p>
                <p>
                  We will retain Personal Data for as long as it is necessary to
                  fulfil the specified purpose for which it was collected, the
                  legal or business purposes of Air India, as described in this
                  Privacy Policy and in line with our data retention policies,
                  or as required by relevant laws. When erasing Personal Data,
                  we will take commercially reasonable and technically possible
                  measures as prescribed under applicable laws to make the
                  Personal Data irrecoverable or irreproducible in accordance
                  with the applicable laws.
                </p>
                <p>
                  <b>VII. Your Data Protection Rights</b>
                </p>
                <p>
                  You have certain rights in relation to your personal data and
                  how we process it, depending upon the jurisdiction you are in.
                </p>
                <p>
                  You have the following rights irrespective of the jurisdiction
                  you belong form:
                </p>
                <ul>
                  <li>
                    <b>Right to access</b>: the right to request copies of the
                    Personal Data we hold about you at any time, or that we
                    modify, update or delete such data. This access includes
                    access to information about the processing, such as purpose,
                    categories of data and recipients, duration of the
                    processing, data subjects’ rights and appropriate safeguards
                    in case of third country transfers.
                  </li>
                  <li>
                    <b>Right to rectification</b>: the right to have your
                    Personal Data rectified if it is inaccurate or incomplete.
                    Depending upon the nature of the request, you may be able to
                    update certain sets of personal data on your own.
                  </li>
                  <li>
                    <b>Right to erase</b>: the right to request that we delete
                    or remove your Personal Data from our systems.
                  </li>
                  <li>
                    <b>Right to withdraw consent</b>: the right to withdraw
                    previously given consent to process your Personal Data
                  </li>
                  <li>
                    <b>Right to complain to supervisory authorities:</b> If you
                    wish to make a complaint or are unhappy with the way we
                    process your personal data, you have the right to complain
                    to the appropriate supervisory authority of your
                    jurisdiction. However, we would suggest to first utilize our
                    grievance redressal mechanism or write to the Data
                    Protection Officer before reaching out to the supervisory
                    authorities.
                  </li>
                </ul>
                <p>
                  If you belong from India, you have certain additional rights.
                  The same has been listed below:
                </p>
                <ul>
                  <li>
                    <b>Right to nominate another person: </b>You have the right
                    to nominate any individual to act on your behalf in case of
                    your death or incapacity to exercise applicable rights.
                  </li>
                </ul>
                <p>
                  If you belong from UK/EEA region you have certain additional
                  rights. The same have been listed below:
                </p>
                <ul>
                  <li>
                    <b>Right to restrict our use of your Personal Data</b>: the
                    right to limit the way in which we can use or process your
                    Personal Data.
                  </li>
                  <li>
                    <b>Right to data portability</b>: the right to request that
                    we move, copy or transfer your Personal Data to another data
                    controller in a machine-readable format.
                  </li>
                  <li>
                    <b>Right to object</b>: the right to object to our use or
                    processing of your Personal Data including where we use it
                    for our legitimate interests.
                  </li>
                </ul>
                <p>
                  <b>Please contact us at</b>&nbsp;
                  <a href="mailto:data.privacy@airindia.com">
                    <b>data.privacy@airindia.com</b>
                  </a>
                  <b> </b>if you wish to make a request for exercising the above
                  rights or if you have a grievance related to the processing of
                  your Personal Data. To help us confirm your identity and to
                  ensure that the personal data is only disclosed to authorized
                  individuals, please provide your full name, frequent flyer
                  number (if loyalty member), email ID and phone number
                  registered with us while sending the data subject request.
                  Please note, where required we may also request for additional
                  information before taking any actions on the requests raised
                  by you. If you are raising a data subject request on behalf of
                  another individual, such requests shall be accompanied by
                  appropriate proof of identity of the requester, details of
                  relationship with the person on whose behalf the request is
                  being made and proof of authority for making such a request.
                  <br />
                </p>
                <p>
                  We will not charge you for exercising any rights provided
                  above, unless your request is manifestly unfounded or
                  excessive. Where we are legally permitted to do so, we may
                  refuse your request. If we refuse your request, we will tell
                  you the reasons why within 7 business days.
                </p>
                <p>
                  <b>
                    VIII. Existence of Automated Decision-Making such as
                    Profiling
                  </b>
                </p>
                <p>
                  We may engage in automatic decision making using your Personal
                  Data for marketing purposes in accordance with applicable
                  laws. You have a right to object to such automatic decision
                  making in certain instances, depending on applicable laws.
                  Kindly refer to Section VII to understand how to exercise your
                  rights.
                </p>
                <p>
                  <b>IX. Links</b>
                </p>
                <p>
                  Our website, mobile application, or other services may contain
                  links to other web sites or platforms. Please be aware that we
                  are not responsible for the privacy practices of web sites not
                  operated by us. We encourage you to read the privacy
                  statements of each and every website that collects personally
                  identifiable information. This Privacy Policy applies solely
                  to information collected by our website, mobile application,
                  or other services.
                </p>
                <p>
                  <b>X. Transfer of your Personal Data</b>
                </p>
                <p>
                  (a) The Personal Data that we process may be transferred to
                  countries other than where you are based. For example, we
                  transfer your Personal Data, where some of our processors are
                  located. If you are based in the EU, we rely on standard data
                  protection clauses that are approved by the European
                  Commission for the transfer of Personal Data outside the
                  European Economic Area.
                </p>
                <p>
                  (b) You can find out more information about these transfer
                  mechanisms&nbsp;by contacting us.
                </p>
                <p>
                  <b>XI. Security</b>
                </p>
                <p>
                  We strive to do our best to protect your personal data and
                  undertake all appropriate technical and organizational
                  measures to ensure the same. We constantly review our security
                  practices to mitigate any risk arising out of unauthorized
                  access, accidental data loss, or damage to your personal data.
                </p>
                <p>
                  Our security practices are in alignment with the industry best
                  practices, including storing your account details and personal
                  information on secure servers and conducting regular security
                  and privacy trainings for our employees to make them
                  understand their responsibilities in looking after your
                  information.
                </p>
                <p>
                  <b>XII.&nbsp; Notification of Breach</b>
                </p>
                <p>
                  If you suspect any misuse or loss or unauthorized access to
                  your Personal Data please let us know immediately by
                  contacting us via the contact details given in this Privacy
                  Policy as provided in Section XIV.
                </p>
                <p>
                  <b>XIII. Changes to this Privacy Statement</b>
                </p>
                <p>
                  We will post changes to this Privacy Policy and update the
                  effective date when this Privacy Policy is updated. We may
                  modify this policy and all modifications will be notified to
                  you in accordance with applicable laws. You are free to decide
                  whether to accept a modified version of this Privacy Policy or
                  not.
                </p>
                <p>
                  <b>XIV. Privacy Contact Information</b>
                </p>
                <p>
                  If you have any questions regarding our Privacy Policy or if
                  you want to exercise any of your rights, you can do so by
                  contacting our Data Protection Officer Mr. Davinder Kumar
                  &nbsp;through &nbsp;
                  <a href="mailto:data.privacy@airindia.com">
                    <b>data.privacy@airindia.com</b>
                  </a>
                  .
                </p>
                <p>
                  <b>XV. Cookie Usage</b>
                </p>
                <p>
                  Air India uses cookies to improve your experience of using our
                  website. Please refer to our&nbsp;
                  <a
                    href="/in/en/cookie-policy.html"
                    title="Cookie"
                    id="Cookie"
                  >
                    <b>Cookie Policy</b>
                  </a>
                  &nbsp;for additional details.
                </p>
                <p>
                  <b>
                    <i>13 July 2024</i>
                  </b>
                </p>
              </div>
            </div>
            <div className="row mt-3">
              <img src={DONOTTHINGS} alt="do-not-in-flight" />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TicketPrint;
